import { Pagination, Table } from '@maia/ui';
import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useFilter } from '../../../utils/filter/filter';
import { Invoices, getInvoicesOptions } from './queryOptions';
import { useInvoiceTable } from './tableOptions';

interface InsuranceTableProps {
  invoices: Invoices;
}

export function InvoicesTable(props: InsuranceTableProps) {
  const { invoices } = props;
  const { guid } = useParams({
    from: '/_authenticated/customers/$guid/_layout/invoices',
  });
  const { dispatch: setSearch, mappedState } = useFilter(
    '/customers/$guid/invoices',
  );
  const { data } = useQuery(getInvoicesOptions(guid, mappedState, invoices));

  const table = useInvoiceTable(data);

  const { sorting } = table.getState();

  useEffect(() => {
    setSearch({ type: 'setSort', payload: sorting });
  }, [setSearch, sorting]);

  return (
    <Table
      table={table}
      className="grid-cols-[min-content_min-content_auto_min-content_min-content]"
      paginationSlot={
        data?.pagination ? (
          <Pagination
            {...data.pagination}
            onLimitChange={(limit) =>
              setSearch({ type: 'setLimit', payload: limit })
            }
            onPageChange={(page) =>
              setSearch({ type: 'paginate', payload: page })
            }
          />
        ) : null
      }
    />
  );
}
